import { Box } from "@mui/material";

import type { ScoutToolPart } from "../message/scoutChatMessage";

import { readSkillActivation } from "./scoutSkillActivations";
import { ScoutSkillPill } from "./ScoutSkillPill";

/** Trace-row title for `skill_activate`: "Using the [Compliance Research] skill". */
export function ScoutSkillActivationTitle({ tool }: { tool: ScoutToolPart }) {
  const activation = readSkillActivation(tool);
  if (!activation) {
    return <>Loading a skill…</>;
  }
  if (activation.status === "failed") {
    const label = activation.name ?? (activation.slug ? `/${activation.slug}` : "requested");
    return <>Couldn't load the {label} skill</>;
  }
  return (
    <Box
      component="span"
      sx={{ display: "inline-flex", alignItems: "center", flexWrap: "wrap", columnGap: 0.75 }}
    >
      {activation.status === "running" ? "Loading the" : "Using the"}
      <ScoutSkillPill id={activation.id} slug={activation.slug} name={activation.name} />
      {activation.status === "running" ? "skill…" : "skill"}
    </Box>
  );
}
